import store from '@Store';
import { createSelector } from 'reselect';

export function firstParameterState(fn) {
  return (...args) => {
    return fn(store.getState(), ...args);
  };
}

export function memorizeForNg(selector) {
  const nextSelector = createSelector([selector], (result) => {
    return result && result.toJS();
  });

  return firstParameterState(nextSelector);
}
